import { render } from "./ItemModifierSetForm.vue?vue&type=template&id=b722f6da&scoped=true"
import script from "./ItemModifierSetForm.vue?vue&type=script&lang=js"
export * from "./ItemModifierSetForm.vue?vue&type=script&lang=js"

import "./ItemModifierSetForm.vue?vue&type=style&index=0&id=b722f6da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b722f6da"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QCheckbox,QTooltip,QList,QItem,QItemSection});
